import { call, put } from 'redux-saga/effects'
import EsimsActions from '../Redux/EsimRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'
import { baseFetchToken } from './BaseSaga'

export function * getAllEsims (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getAllEsims, token, action.data)
      if (!res.ok) {
        yield put(EsimsActions.getAllEsimsFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const paginatedData = {
            data: res.data.data,
            page,
            total
          }
          yield put(EsimsActions.getAllEsimsSuccess(paginatedData))
        } else {
          yield put(EsimsActions.getAllEsimsFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(EsimsActions.getAllEsimsFailure())
  }
}

export function * updateEsimData (api, action) {
  yield baseFetchToken(
    api.updateEsimData,
    action.data,
    getToken,
    EsimsActions.esimUpdateSuccess,
    EsimsActions.esimUpdateFailure
  )
}

export function * updateEsimCountry (api, action) {
  yield baseFetchToken(
    api.updateEsimCountry,
    action.data,
    getToken,
    EsimsActions.esimUpdateCountrySuccess,
    EsimsActions.esimUpdateCountryFailure
  )
}

export function * updateEsimVarian (api, action) {
  yield baseFetchToken(
    api.updateEsimVariant,
    action.data,
    getToken,
    EsimsActions.esimUpdateVariantSuccess,
    EsimsActions.esimUpdateVariantFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/EsimSagas.js